import { render, staticRenderFns } from "./kanban.vue?vue&type=template&id=8d9c1116"
import script from "./kanban.vue?vue&type=script&lang=js"
export * from "./kanban.vue?vue&type=script&lang=js"
import style0 from "./kanban.vue?vue&type=style&index=0&id=8d9c1116&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports